import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ClassService, UnitsService, UserService, ScriptLoaderService } from './../../../../../_services';
import { Config, Unit, Income } from './../../../../../_models';
import { Base } from './../../../../../_models/Classes';

import { CurrencyPipe } from '@angular/common';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { User } from '../../../../../_models/user';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SwalComponent, SwalPartialTargets } from '@toverux/ngx-sweetalert2';

@Component({
    selector: 'app-users-list',
    templateUrl: "./users-list.component.html",
    styleUrls: ['./users-list.component.scss']
})
export class UsersListComponent implements OnInit, AfterViewInit {
    @ViewChild('deleteQuestionSwal') private deleteQuestionSwal: SwalComponent;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('errorsListSwal') private errorsListSwal: SwalComponent;
    data: Config = new Config(null, null, null, null, null, null, null);
    public usuarios: any[] = [];
    model = new User(null, null, '', '', ' ', '');
    name: string = this.model.name;
    email: string = this.model.email;
    role: any;
    username: string = this.model.username;
    roles: any[] = [];
    public id_user: number;
    public user: any[] = [];
    public role_user: any;
    closeResult: string;
    public errors: string[];
    currentUser: any = JSON.parse(localStorage.getItem('currentUser'));


    tableMessages = {
        emptyMessage: 'No hay usuarios',
        totalMessage: ''
    };
    @BlockUI() blockUI: NgBlockUI;
    loadingIndicator: boolean = true;
    reorderable: boolean = true;
    selectedUser: number;

    static initialClass: string =
    'm-page--wide m-header--fixed m-header--fixed-mobile m-footer--push m-aside--offcanvas-default';
    constructor(
        private _classService: ClassService,
        private _script: ScriptLoaderService,
        private _userService: UserService,
        private _route: ActivatedRoute,
        private modalService: NgbModal,
        private activeModal: NgbActiveModal,
        public readonly swalTargets: SwalPartialTargets) { }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this._script.loadScripts('app-users-list',
            ['assets/demo/demo2/custom/crud/forms/widgets/bootstrap-select.js']);
        this._classService.setClass(document.body, UsersListComponent.initialClass);
        this.allUsers();
        this.getRoles();

    }

    allUsers() {
        this._userService.getAll().subscribe(data => {
            this.usuarios = data.data;
        }, err => {
            console.log(err);
        }, () => {

        });
    }

    search() {
        this.blockUI.start();
        this.role = ($('#roles1').val());

        this._userService.search(this.buildSearchString())
            .subscribe(data => {
                this.usuarios = data;
            }, err => {
                this.blockUI.stop();
                console.log(err);
            }, () => {
                this.blockUI.stop();
            });
    }

    buildSearchString() {
        let result = ``;

        if (this.name) {
            result += `name=${this.name}&`;
        }

        if (this.email) {
            result += `email=${this.email}&`;
        }

        if (this.role) {
            result += `role=${this.role}`;
        }

        return result;
    }

    clear() {
        this.model.name = '';
        this.model.email = '';
        this.model.password = '';
        this.model.username = '';
        this.model.role = null;
        this.search();
    }

    getRoles(option = 1) {
        this._userService.getAllRoles().subscribe(data => {
            this.roles = data.data;
            ($("#roles" + option).html(this.getOptions(this.roles, option)) as any)
                .selectpicker('refresh');
        }, err => {
            this.blockUI.stop();
            console.log(err);
        }, () => {
            this.blockUI.stop();
        });
    }

    getOptions(roles, option = 1) {
        let options;
        if (option == 1) {
            options = `<option value="">Todos</option>`;
        } else {
            options = `<option value="">Seleccione un rol</option>`;
        }

        for (let i in roles) {
            options += `<option value="${roles[i].id}">${roles[i].name}</option>`;

        }
        return options;

    }

    getUser(id) {
        this._userService.get(id).subscribe(data => {
            this.user = data.data;
            this.role_user = data.data.role[0];
            this.model.id = this.user['id'];
            this.model.name = this.user['name'];
            this.model.email = this.user['email'];
            this.model.username = this.user['username'];
            this.model.role = this.role_user['id'];
        }, err => {
            console.log(err);
        }, () => {

        });
    }

    openModalEdit(modal, id) {
        this._script.loadScripts('app-users-list',
            ['assets/demo/demo2/custom/crud/forms/widgets/bootstrap-select.js']);
        this.getUser(id);

        this.modalService.open(modal, { size: 'lg' });

        setTimeout(() => this._userService.getAllRoles().subscribe(data => {
            this.roles = data.data;
            let options;
            if (this.role_user) {
                options = `<option value="${this.role_user['id']}">${this.role_user['name']}</option>`;
            } else {
                options = `<option value="">Sin rol</option>`;
            }
            for (let i in this.roles) {
                if (this.role_user['name'] != this.roles[i].name)
                    options += `<option value="${this.roles[i].id}">${this.roles[i].name}</option>`;
            }
            ($("#roles2").html(options) as any)
                .selectpicker('refresh')

        }, err => {
            this.blockUI.stop();
            console.log(err);
        }, () => {
            this.blockUI.stop();
        }), 500);
    }

    postEdit(passResetFrom) {
        this.blockUI.start();
        this.user['id'] = this.model.id;
        this.user['name'] = this.model.name;
        this.user['email'] = this.model.email;
        this.user['username'] = this.model.username;
        this.user['role'] = this.model.role;
        this._userService.put(this.user['id'], this.user).subscribe(response => {
            if (response.error) {
                this.blockUI.stop();
                this.errorsListSwal.show();
                console.log(response.error);
            } else {
                if (response.status == "ok") {
                    this.blockUI.stop();
                    this.successSwal.text = response.message;
                    this.successSwal.show();
                } else {
                    this.blockUI.stop();
                    this.successSwal.text = response.message;
                    this.successSwal.show();
                }
            }
        }, error => {
            this.errors = error.error.error.errors;
            this.blockUI.stop();
            this.errorsListSwal.show();
        })
    }

    deleteUser(id) {
        this._userService.delete(id).subscribe(response => {
            if (response['status'] == 'ok') {
                this.successSwal.text = response['message'];
                this.successSwal.show();
            } else {
                this.successSwal.text = response['message'];
                this.successSwal.show();
            }

        }, error => {
            this.errorSwal.text = error.error.error.message;
            this.errorSwal.show();
        });
    }
    openModalCreate(modal) {
        this.clear();
        this._script.loadScripts('app-users-list',
            ['assets/demo/demo2/custom/crud/forms/widgets/bootstrap-select.js']);
        this.getRoles(3);
        this.modalService.open(modal, { size: 'lg' });

    }

    postCreate(passResetFrom) {
        this.blockUI.start();
        this._userService.post(this.model).subscribe(response => {
            if (response.status == "ok") {
                this.blockUI.stop();
                this.successSwal.text = response.message;
                this.successSwal.show();

            } else {
                this.blockUI.stop();
                this.errorsListSwal.text = response.message;
                this.errorsListSwal.show();
            }
        }, error => {
            this.errors = error.error.error.errors;
            this.blockUI.stop();
            this.errorsListSwal.show();
        })

    }

    reload() {
        window.location.reload();
    }

}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/users/users-list/users-list.component.ts